import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line camelcase
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { MaterialReactTable } from 'material-react-table';
import { Box } from '@mui/material';
import data from './mockData';
import { setDashboardDrillInterfaceSelected } from '../../../store/fuse/dashboard';
import { setProgressBarColor } from '../utils';

const MetricIndicatorType = {
  success: 'green-primary',
  warning: 'yellow-primary',
  error: 'red-primary',
};

// const getInterfaceColor = (value) => {
//   const colors = setProgressBarColor(Number(value), 'disponibilidad');
//   return colors[0];
// };

const Interfaces = () => {
  const dispatch = useDispatch();
  const interfacesData = useSelector((state) => state?.fuse?.dashboard?.nodeDetails?.interfaces);
  const currentMetricThresholds = useSelector((state) => state?.fuse?.dashboard?.metricThresholds);

  const getInterfaceColor = (value) => {
    const colors = setProgressBarColor(Number(value), 'disponibilidad', currentMetricThresholds);
    return colors[0];
  };

  const columns = [
    {
      header: 'Estado',
      accessorKey: 'estado',
      Cell: ({ cell }) => {
        const percentValue = (cell?.row?.original?.anchobandabajada * 100) / cell?.row?.original?.anchobandabajadaContratado;
        const percentValueColor = getInterfaceColor(100 - percentValue);
        return (
          <Box className="flex flex-row justify-center" sx={{ width: '100%' }}>
            <section className={MetricIndicatorType[percentValueColor] || 'grey-primary'} />{' '}
          </Box>
        );
      },
    },
    {
      header: 'Interface',
      accessorKey: 'dsinterface',
    },
    {
      header: 'Ancho Banda Subida',
      accessorKey: 'anchobandasubida',
      Cell: ({ cell }) => <span>{`${cell.getValue()} Mbps`}</span>,
    },
    {
      header: 'Ancho Banda Bajada',
      accessorKey: 'anchobandabajada',
      Cell: ({ cell }) => <span>{`${cell.getValue()} Mbps`}</span>,
    },
    {
      header: 'Ancho Banda Subida Contratado',
      accessorKey: 'anchobandasubidaContratado',
      Cell: ({ cell }) => <span>{`${cell.getValue()} Mbps`}</span>,
    },
    {
      header: 'Ancho Banda Bajada Contratado',
      accessorKey: 'anchobandabajadaContratado',
      Cell: ({ cell }) => <span>{`${cell.getValue()} Mbps`}</span>,
    },
  ];

  const handleOnRowClick = (event, row) => {
    event.preventDefault();
    dispatch(setDashboardDrillInterfaceSelected(row.original.equipments));
  };

  return (
    <div style={{ width: '90%' }}>
      <MaterialReactTable
        // eslint-disable-next-line camelcase
        localization={MRT_Localization_ES}
        columns={columns}
        data={interfacesData}
        enableColumnResizing
        enableGrouping
        enableStickyHeader
        enableStickyFooter
        initialState={{
          density: 'compact',
          expanded: true, // expand all groups by default
          pagination: { pageIndex: 0, pageSize: 15 },
          // sorting: [{ id: 'state', desc: false }], // sort by state by default
        }}
        muiToolbarAlertBannerChipProps={{ color: 'primary' }}
        muiTableContainerProps={{ sx: { maxHeight: 700 } }}
        enableFullScreenToggle={false}
        muiTableBodyRowProps={({ row }) => ({
          onClick: (event) => {
            handleOnRowClick(event, row);
          },
          sx: {
            cursor: 'pointer',
          },
        })}
      />
    </div>
  );
};

export default Interfaces;
